// Site access intent (C.2b-access) — publication (HA public exposure) +
// netbird (remote-access overlay), both 1:1 per site. Mirrors backend
// PublicationIn/Out + NetbirdIn/Out in api/v1/site_access.py. PUT is
// patch-like; all fields optional server-side (the UI locally requires the
// render-critical ones).

export type PublicationMode = "option_a_netbird_reverse_proxy";
export type TlsOwner = "khired_infra" | "client";
export type EnrollmentMethod = "setup_key";

export interface PublicationIn {
  ha_public_hostname?: string | null;
  publication_mode?: PublicationMode | null;
  tls_owner?: TlsOwner | null;
  published_internal_host?: string | null;
  vendor_extras?: Record<string, unknown>;
  notes?: string[];
}
export interface PublicationConfig extends PublicationIn {
  site_id: string;
}

export interface NetbirdIn {
  management_url?: string | null;
  account_group?: string | null;
  site_group?: string | null;
  gateway_group?: string | null;
  admin_group?: string | null;
  gateway_peer_name?: string | null;
  gateway_host?: string | null;
  gateway_lan_ip?: string | null;
  route_cidrs?: string[];
  enrollment_method?: EnrollmentMethod | null;
  setup_key_secret_ref?: string | null;
  vendor_extras?: Record<string, unknown>;
  notes?: string[];
}
export interface NetbirdConfig extends NetbirdIn {
  site_id: string;
}

export const PUBLICATION_MODES: ReadonlyArray<{ value: PublicationMode; label: string }> = [
  { value: "option_a_netbird_reverse_proxy", label: "Option A — NetBird reverse proxy" },
];
export const TLS_OWNERS: ReadonlyArray<{ value: TlsOwner; label: string }> = [
  { value: "khired_infra", label: "Khired infra" },
  { value: "client", label: "Client" },
];
export const ENROLLMENT_METHODS: ReadonlyArray<{ value: EnrollmentMethod; label: string }> = [
  { value: "setup_key", label: "Setup key" },
];
